/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { FormikProps } from "formik";
import { AssignDialogFormValuesType } from "./AssignDialogFormWrapper";
import ATMSelect from "src/components/UI/atoms/formFields/ATMSelect/ATMSelect";
import { useGetAllQuestionsWithPaginationQuery } from "src/services/QuestionBankServices";
import {
  setDialogPage,
  setDialogTotalItems,
  setDialogItems,
  SetDialogRowsPerPage,
} from "src/redux/slices/AssignmentSlice";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import { useParams } from "react-router-dom";
import { showToast } from "src/utils/showToaster";
import { handleValidNumber } from "src/utils/validations/numberInput";
import { useGetAllTagsQuery } from "src/services/TagServices";
import ATMTable, {
  columnTypes,
} from "src/components/UI/atoms/ATMTable/ATMTable";
import ATMPagination from "src/components/UI/atoms/ATMPagination/ATMPagination";
import ATMMultiSelect from "src/components/UI/atoms/formFields/ATMMultiSelect/ATMMultiSelect";

type Props = {
  formikProps: FormikProps<AssignDialogFormValuesType>;
  onClose: () => void;
  addAssign: any;
  addLoading: boolean;
  batchData: any;
};
const ComplexityOptions = [
  {
    label: "SUPER_EASY",
    value: "SUPER_EASY",
  },
  {
    label: "EASY",
    value: "EASY",
  },
  {
    label: "MEDIUM",
    value: "MEDIUM",
  },
  {
    label: "HARD",
    value: "HARD",
  },
];

const ComplexityClasses = (level: string) => {
  switch (level) {
    case "SUPER_EASY":
      return {
        label: "Super Easy",
        class: "bg-lime-600",
      };
    case "EASY":
      return {
        label: "Easy",
        class: "bg-green-800",
      };
    case "MEDIUM":
      return {
        label: "Medium",
        class: "bg-amber-500",
      };
    case "HARD":
      return {
        label: "Hard",
        class: "bg-red-700",
      };
  }
};

const AssignDialogForm = ({
  formikProps,
  onClose,
  addAssign,
  addLoading,
  batchData,
}: Props) => {
  const { values, setFieldValue, handleBlur } = formikProps;
  const dispatch = useDispatch();
  const { batchId } = useParams();
  const [questionId , setQuestionId] = useState<any>('')
  const { dialogPage, dialogItems, dialogTotalItems, dialogrowsPage } =
    useSelector((state: RootState) => state.assignment); 


  const addAssignMentFunction = ({row , isLoading}:any) => {
    return batchData?.questionId?.includes(row?._id) ? (
      <ATMLoadingButton
       isLoading={isLoading && questionId === row?._id}
        onClick={() => { 
          setQuestionId(row?._id)
          addAssign({
            batchId: batchId,
            questionId: row?._id,
            assignstatus: false,
          }).then((res: any) => {
            if (res?.error) {
              showToast("error", res?.error?.data?.message);
            } else {
              if (res?.data?.status) {
                showToast("success", res?.data?.message);
              } else {
                showToast("error", res?.data?.message);
              }
            }
          });
        }}
        className="w-24 h-[30px] rounded-md bg-red-700 text-white font-medium"
      >
        Remove
      </ATMLoadingButton>
    ) : (
      <ATMLoadingButton 
      isLoading={isLoading && questionId === row?._id}
        onClick={() => { 
          setQuestionId(row?._id)
          addAssign({
            batchId: batchId,
            questionId: row?._id,
            assignstatus: true,
          }).then((res: any) => {
            if (res?.error) {
              showToast("error", res?.error?.data?.message);
            } else {
              if (res?.data?.status) {
                showToast("success", res?.data?.message);
              } else {
                showToast("error", res?.data?.message);
              }
            }
          });
        }}
        className="w-24 h-[30px] rounded-md bg-green-700 text-white font-medium"
      >
        Add
      </ATMLoadingButton>
    );
  };

  const columns: columnTypes[] = [
    {
      field: "title",
      headerName: "TITLE",
      flex: "flex-[1_1_0%]",
      extraClasses: "min-w-[120x]",
      renderCell: (row: any) => <div className="capitalize"> {row?.title} </div>,
    },
  
    {
      field: "complexity",
      headerName: "COMPLEXITY",
      flex: "flex-[1_1_0%]",
      extraClasses: "min-w-[120x]",
      renderCell: (row: any) => (
        <div className="p-2 capitalize">
          <span
            className={`${
              ComplexityClasses(row?.complexity)?.class
            } px-3 py-1 rounded-md text-xs text-white`}
          >
            {ComplexityClasses(row?.complexity)?.label}
          </span>
        </div>
      ),
    },
    {
      field: "tags",
      headerName: "Tags",
      flex: "flex-[1_1_0%]",
      extraClasses: "min-w-[120x]",
      renderCell: (row: any) => (
        <div>
          {row?.tags?.map((el: any, ind: any) => (
            <span className="text-[11px] font-semibold">
              {row?.tags?.length === ind + 1 ? el : `${el} ,`}{" "}
            </span>
          ))}
        </div>
      ),
    },
    {
      field: "action",
      headerName: "status",
      flex: "flex-[1_1_0%]",
      extraClasses: " py-2",
      renderCell: (row: any) => (
        <div className="flex justify-end">
         {addAssignMentFunction({
          row: row ,
          isLoading : addLoading 
         })}
        </div>
      ),
    },
  ];

  //Get Question Listing
  const { data, isLoading, isFetching } = useGetAllQuestionsWithPaginationQuery(
    {
      limit: dialogrowsPage,
      searchValue: values?.searchValue || "",
      params: ["question"],
      page: dialogPage,
      filterBy: [
        {
          fieldName: "tags",
          value: values?.tagId?.length ? values?.tagId?.map((el:any)=>el?.value) : [],
        },

        {
          fieldName: "complexity",
          value: values?.complexity?.value ? [values?.complexity?.value] : [],
        },
        {
          fieldName: "order",
          value: values?.order ? Number(values?.order) : [],
        },
      ],
      dateFilter: {},
      orderBy: "createdAt",
      orderByValue: -1,
      isPaginationRequired: true,
    }
  );

  //Tags Data
  const {
    data: AllTagsData,
    isLoading: tagsDataIsLoading,
    isFetching: tagsDataIsFetching,
  } = useGetAllTagsQuery("");
  const tagsOptions = AllTagsData?.data?.map((el: any) => {
    return {
      label: el?.tagName,
      value: el?.tagName,
    };
  });

  useEffect(() => {
    if (!isLoading && !isFetching) {
      dispatch(setDialogItems(data?.data));
      dispatch(setDialogTotalItems(data?.totalItem));
    }
  }, [isFetching, isLoading, data]);

  return (
    <>
      <div className="p-4 h-screen w-full">
        {/* HEADING AND CANCEL BUTTON */}
        <div className="flex justify-between items-center">
          <div className="text-xl font-medium">Assignment</div>
          <button type="button" className="hover:bg-hover" onClick={onClose}>
            Cancel
          </button>
        </div>
        {/* FILTER BOX */}
        <div className="shadow-md p-2">
          <div className="flex justify-end">
            <span
              onClick={() => {
                setFieldValue("tagId", "");
                setFieldValue("searchValue", "");
                setFieldValue("complexity", "");
                setFieldValue("order", "");
              }}
              className="text-amber-600 text-[14px] font-medium cursor-pointer"
            >
              Reset Filters
            </span>
          </div>
          <div className="grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 xs:grid-cols-1 gap-6  pb-2">
            {/* Tags */}

            <div>
                <ATMMultiSelect
            name="tagId"
            value={values?.tagId}
            onChange={(newValue) => setFieldValue("tagId", newValue)}
            onBlur={handleBlur}
            label="Tags"
            placeholder="Select Tags"
            options={tagsOptions}
            isLoading={tagsDataIsLoading || tagsDataIsFetching}
          />
            </div>

            {/* Complexity */}
            <div >
              <ATMSelect
                name="complexity"
                required
                value={values?.complexity}
                onChange={(newValue) => setFieldValue("complexity", newValue)}
                onBlur={handleBlur}
                label="Complexity"
                placeholder="Select Complexity"
                options={ComplexityOptions}
              />
            </div>
            {/* Order */}
            <div>
              <ATMTextField
                name="order"
                required
                value={values?.order}
                onChange={(e) =>
                  handleValidNumber(e) && setFieldValue("order", e.target.value)
                }
                onBlur={handleBlur}
                label="Order"
                placeholder="Order"
              />
            </div>
          </div>
          <div className="grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 xs:grid-cols-1">
            {/* Field Label */}
            <div className="">
              <ATMTextField
                name="searchValue"
                value={values?.searchValue}
                onChange={(e) => setFieldValue("searchValue", e.target.value)}
                label="Search"
                placeholder="search"
                onBlur={handleBlur}
              />
            </div>
          </div>
        </div> 

        {/* TABLE AND PAGINATION */}
          <div>
            <div className="max-h-[500px] overflow-scroll">
              <ATMTable columns={columns} rows={dialogItems} isLoading={isLoading || isFetching} extraClasses="z-0" />
            </div>
            <div className="p-4 py-2 flex justify-end">
              <ATMPagination
                page={dialogPage}
                rowsPerPage={dialogrowsPage}
                onPageChange={(newPage) => dispatch(setDialogPage(newPage))}
                onRowsPerPageChange={(newPage) =>
                  dispatch(SetDialogRowsPerPage(newPage))
                }
                rowCount={dialogTotalItems}
                rows={dialogItems}
              />
            </div>
          </div>
      </div>
    </>
  );
};

export default AssignDialogForm;
